"use client"

import Icon from "@ant-design/icons"
import type { GetProps } from "antd"
import type { SVGProps } from "react"

const HOTELS_PATHS = [
  "M535.71,559.92H64.29c-5.84,0-10.57-4.73-10.57-10.57V153.17c0-5.84,4.73-10.57,10.57-10.57h102.04c5.84,0,10.57,4.73,10.57,10.57s-4.73,10.57-10.57,10.57h-91.48v374.89h450.28V163.89h-91.48c-5.84,0-10.57-4.73-10.57-10.57s4.73-10.57,10.57-10.57h102.04c5.84,0,10.57,4.73,10.57,10.57v396.18c0,5.68-4.73,10.41-10.57,10.41Z",
  "M176.9,392.42h246.04V61.22h-246.04v331.2h0ZM433.66,413.71H166.34c-5.84,0-10.57-4.73-10.57-10.57V50.65c0-5.84,4.73-10.57,10.57-10.57h267.33c5.84,0,10.57,4.73,10.57,10.57v352.5c.16,5.84-4.73,10.57-10.57,10.57Z",
  "M151.35,445.57h297.29v-31.86H151.35v31.86h0ZM459.37,466.86H140.79c-5.84,0-10.57-4.73-10.57-10.57v-53.15c0-5.84,4.73-10.57,10.57-10.57h318.59c5.84,0,10.57,4.73,10.57,10.57v53.15c0,5.84-4.73,10.57-10.57,10.57Z",
  "M176.9,538.78h246.04v-71.92h-246.04v71.92h0ZM433.66,559.92H166.34c-5.84,0-10.57-4.73-10.57-10.57v-93.05c0-5.84,4.73-10.57,10.57-10.57h267.33c5.84,0,10.57,4.73,10.57,10.57v93.05c.16,5.84-4.73,10.57-10.57,10.57Z",
  "M231.31,183.76h30.6v-61.82h-30.6v61.82h0ZM272.64,204.9h-51.89c-5.84,0-10.57-4.73-10.57-10.57v-83.12c0-5.84,4.73-10.57,10.57-10.57h51.89c5.84,0,10.57,4.73,10.57,10.57v83.12c0,5.84-4.73,10.57-10.57,10.57Z",
  "M337.93,183.76h30.75v-61.82h-30.75v61.82h0ZM379.25,204.9h-51.89c-5.84,0-10.57-4.73-10.57-10.57v-83.12c0-5.84,4.73-10.57,10.57-10.57h51.89c5.84,0,10.57,4.73,10.57,10.57v83.12c0,5.84-4.73,10.57-10.57,10.57Z",
  "M231.31,331.86h30.6v-61.82h-30.6v61.82h0ZM272.64,353.15h-51.89c-5.84,0-10.57-4.73-10.57-10.57v-83.12c0-5.84,4.73-10.57,10.57-10.57h51.89c5.84,0,10.57,4.73,10.57,10.57v83.12c0,5.68-4.73,10.57-10.57,10.57Z",
  "M337.93,331.86h30.75v-61.82h-30.75v61.82h0ZM379.25,353.15h-51.89c-5.84,0-10.57-4.73-10.57-10.57v-83.12c0-5.84,4.73-10.57,10.57-10.57h51.89c5.84,0,10.57,4.73,10.57,10.57v83.12c0,5.68-4.73,10.57-10.57,10.57Z",
  "M259.7,538.78h80.75v-22.71h-80.75v22.71h0ZM351.02,559.92h-101.88c-5.84,0-10.57-4.73-10.57-10.57v-44c0-5.84,4.73-10.57,10.57-10.57h101.88c5.84,0,10.57,4.73,10.57,10.57v44c0,5.84-4.73,10.57-10.57,10.57Z",
] as const

type CustomIconComponentProps = GetProps<typeof Icon>

export type HotelsIconProps = Partial<CustomIconComponentProps> & {
  color?: string
}

type HotelsSvgProps = SVGProps<SVGSVGElement> & {
  color?: string
}

const HotelsSvg = ({ color = "currentColor", ...props }: HotelsSvgProps) => (
  <svg
    viewBox="0 0 600 600"
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    {HOTELS_PATHS.map((d) => (
      <path key={d} d={d} fill={color} />
    ))}
  </svg>
)

const HotelsIcon = ({ color, ...props }: HotelsIconProps) => (
  <Icon
    component={(svgProps: SVGProps<SVGSVGElement>) => (
      <HotelsSvg {...svgProps} color={color} />
    )}
    {...props}
  />
)

export default HotelsIcon
